<template>
    <div>
        <v-data-table
            loading-text="Loading..."
            :disable-filtering="true"
            :disable-sort="true"
            :loading="partners.loading"
            :headers="partners.headers"
            :items="partners.items"
            :options.sync="partners.options"
            :items-per-page="partners.options.itemsPerPage"
            :server-items-length="partners.totals"
            :item-class="rowClass"
            :footer-props="{
                showFirstLastPage: true,
                showCurrentPage: true,
                disableItemsPerPage: true,
                itemsPerPageOptions: [partners.options.itemsPerPage]
            }">
            <template v-slot:item.name="{ item, value }">
                <span class="font-weight-bold">
                    {{ value }}
                </span>
            </template>

            <template v-slot:item.email="{ item, value }">
                <div>{{ value }}</div>

                <template v-if="!item.is_email_verified">
                    <div>
                        <span class="text-caption error--text">(not verified)</span>
                    </div>
                </template>
            </template>

            <template v-slot:item.signup_date="{ item }">
                <span class="text--secondary text-caption">
                    {{ item.signup_date }} {{ item.signup_time }}
                </span>
            </template>

            <template v-slot:item.actions="{ item }">
                <div>
                    <template v-if="!item.is_approved">
                        <template v-if="item.is_email_verified">
                            <v-btn
                                small
                                color="success"
                                :loading="loading[parseInt(item.id)]"
                                @click="approve(item)">
                                Approve
                            </v-btn>
                        </template>
                    </template>

                    <v-btn
                        small
                        color="primary"
                        @click.stop="openPartner(item)">
                        View
                    </v-btn>
                </div>
            </template>
        </v-data-table>

        <v-navigation-drawer
            v-model="partner.view"
            absolute
            temporary
            right
            width="75%"
            color="white"
        >
            <template v-slot:prepend>
                <v-list-item two-line>
                    <v-list-item-avatar>
                        <v-icon x-large>mdi-account-circle</v-icon>
                    </v-list-item-avatar>

                    <v-list-item-content>
                        <v-list-item-title>
                            {{ partner.item.name }}
                        </v-list-item-title>
                        <v-list-item-subtitle class="text--secondary text-subtitle-2">
                            Sign Up Date: {{ partner.item.signup_date }} {{ partner.item.signup_time }}
                        </v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-action>
                        <v-btn icon @click.stop="closePartner()">
                            <v-icon large>mdi-close</v-icon>
                        </v-btn>
                    </v-list-item-action>
                </v-list-item>
            </template>

            <v-divider></v-divider>

            <v-simple-table>
                <template v-slot:default>
                    <tbody>
                    <tr>
                        <td class="font-weight-bold">First Name</td>
                        <td>{{ partner.item.first_name }}</td>
                    </tr>
                    <tr>
                        <td class="font-weight-bold">Last Name</td>
                        <td>{{ partner.item.last_name }}</td>
                    </tr>
                    <tr>
                        <td class="font-weight-bold">Email</td>
                        <td>
                            {{ partner.item.email }}
                            <template v-if="!partner.item.is_email_verified">
                                <div>
                                    <span class="text-caption error--text">(not verified)</span>
                                </div>
                            </template>
                        </td>
                    </tr>
                    <tr>
                        <td class="font-weight-bold">Company</td>
                        <td>{{ partner.item.company }}</td>
                    </tr>
                    <tr>
                        <td class="font-weight-bold">Phone</td>
                        <td>{{ partner.item.phone }}</td>
                    </tr>
                    <tr>
                        <td class="font-weight-bold">Industry</td>
                        <td>{{ partner.item.industry }}</td>
                    </tr>
                    <tr>
                        <td class="font-weight-bold">Estimate of potential clients</td>
                        <td>{{ partner.item.clients_count }}</td>
                    </tr>
                    <tr>
                        <td class="font-weight-bold">Location</td>
                        <td v-html="partner.item.location"></td>
                    </tr>
                    </tbody>
                </template>
            </v-simple-table>

            <template v-slot:append>
                <v-card
                    v-if="Object.keys(partner.item).length"
                    flat
                    tile>
                    <v-divider></v-divider>

                    <v-card-actions>
                        <template
                            v-if="partner.item.is_email_verified && !partner.item.is_approved">
                            <v-btn
                                color="success"
                                :loading="loading[parseInt(partner.item.id)]"
                                @click="approve(partner.item)">
                                <v-icon>mdi-check</v-icon>
                                Approve Partner
                            </v-btn>
                        </template>

                        <v-spacer />

                        <v-btn
                            color="error">
                            <v-icon>mdi-account-cancel</v-icon>
                            Ban Partner
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </template>
        </v-navigation-drawer>
    </div>
</template>

<script>
export default {
    data() {
        return {
            partners: {
                options: {
                    page: 1,
                    itemsPerPage: 20
                },
                loading: false,
                totals: 0,
                headers: [
                    {
                        text: 'Partner',
                        value: 'name',
                    },
                    {
                        text: '',
                        value: 'email',
                    },
                    {
                        text: 'Country',
                        value: 'country',
                    },
                    {
                        text: 'Sign Up Date',
                        value: 'signup_date',
                    },
                    {
                        text: 'Actions',
                        value: 'actions',
                        align: 'end',
                    },
                ],
                items: []
            },
            partner: {
                view: false,
                item: {}
            },
            loading: {}
        }
    },

    watch: {
        'partners.options.page'(new_val, old_val) {
            this.pullPartners();
        },
    },

    mounted() {
        this.pullPartners();
    },

    methods: {
        rowClass(item) {
            return item.is_approved
                ? 'green lighten-4'
                : '';
        },

        pullPartners() {
            (new DBPartners(this))
                .addParam('page', this.partners.options.page)
                .before(() => {
                    this.partners.loading = true;
                })
                .after(response => {
                    this.partners.loading = false;
                    this.partners.totals = response.data.data.total;
                    this.partners.items = response.data.data.data;
                    this.partners.options.page = response.data.data.current_page;
                    this.partners.options.itemsPerPage = response.data.data.per_page;
                })
                .error(error => {
                    this.partners.loading = false;
                })
                .get();
        },

        openPartner(item) {
            this.partner.view = !this.partner.view;
            this.partner.item = item;
        },

        closePartner() {
            this.partner.view = false
        },

        approve(item) {
            (new DBPartners(this))
                .addParam('id', item.id)
                .before(() => {
                    this.$set(this.loading, parseInt(item.id), true);
                })
                .after(response => {
                    this.$set(this.loading, parseInt(item.id), false);

                    this.pullPartners();
                    this.closePartner();
                })
                .error(error => {
                    this.$set(this.loading, parseInt(item.id), false);
                })
                .approve();
        }
    }
}
</script>
